/**
 * Email Queries / All Quotes list tour.
 *
 * Both routes render QuotesTable.jsx in a split layout: list on the left,
 * customer conversation on the right. The tour walks an operator through:
 * find a query → read the thread → open the full workspace.
 *
 * Anchors (verified present in QuotesTable.jsx):
 *   eq-search-bar    Search + filter bar at the top
 *   eq-subject-list  Left rail list of quotes / subjects
 *   eq-conversation  Right-side thread preview
 *   eq-pagination    Pagination controls at the bottom
 */

export const emailQueriesTour = {
  id: "email-queries",
  label: "Quotes List — Find & Open",
  steps: [
    {
      target: "eq-search-bar",
      title: "Find a quote fast",
      description:
        "Search by subject, route, or quote ID. The filter dropdown narrows by field — useful when a keyword collides across a lot of records.",
      hint: "On Email Queries, a 'False flags only' toggle helps you review misclassified items.",
      placement: "bottom",
    },
    {
      target: "eq-subject-list",
      title: "Pick a quote from the list",
      description:
        "Each row is a customer enquiry. Click any row to load its conversation on the right. The status badge and route help you prioritise at a glance.",
      placement: "right",
    },
    {
      target: "eq-conversation",
      title: "Preview the conversation",
      description:
        "The customer email thread loads here so you can scan it before jumping in. When ready, open the full quote workspace to add rates and build the cost table.",
      hint: "Use the 'Open Quote' action inside the preview to enter the full workspace.",
      placement: "left",
    },
    {
      target: "eq-pagination",
      title: "Move through your backlog",
      description:
        "Page controls and the rows-per-page selector live here. Bump rows-per-page up when you're triaging a large inbox.",
      placement: "top",
    },
  ],
};
